/* tslint:disable */
import {
  Users,
  Worker,
  Task
} from '../index';

declare var Object: any;
export interface ConversationInterface {
  "sfdcId"?: string;
  "Name"?: string;
  "OwnerId"?: string;
  "LastModifiedById"?: string;
  "Conversation_Date__c"?: Date;
  "CurrencyIsoCode"?: string;
  "CreatedById"?: string;
  "CreatedDate"?: Date;
  "Followers__c"?: number;
  "Initated_By_Member__c"?: string;
  "IsDeleted"?: boolean;
  "Likes__c"?: number;
  "LastModifiedDate"?: Date;
  "LastReferencedDate"?: Date;
  "LastViewedDate"?: Date;
  "Main_Message_Reply_Conversation__c"?: string;
  "Message__c"?: string;
  "Original_Post__c"?: boolean;
  "Parent_Conversation__c"?: string;
  "Parent_Reply_Conversation__c"?: string;
  "Priority__c"?: string;
  "Reply__c"?: boolean;
  "Title__c"?: string;
  "IsServiceODelete"?: boolean;
  "documentCount"?: number;
  "APEX_PgMO_Tasks__c"?: string;
  "Selected_Member__c"?: string;
  "PgMO_Tasks__c"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  owner?: Users;
  worker?: Worker;
  parentId?: Conversation;
  ReplyId?: Conversation;
  parentConversation?: Conversation[];
  replyConversation?: Conversation[];
  replyMainMessageConversation?: Conversation[];
  task?: Task;
}

export class Conversation implements ConversationInterface {
  "sfdcId": string;
  "Name": string;
  "OwnerId": string;
  "LastModifiedById": string;
  "Conversation_Date__c": Date;
  "CurrencyIsoCode": string;
  "CreatedById": string;
  "CreatedDate": Date;
  "Followers__c": number;
  "Initated_By_Member__c": string;
  "IsDeleted": boolean;
  "Likes__c": number;
  "LastModifiedDate": Date;
  "LastReferencedDate": Date;
  "LastViewedDate": Date;
  "Main_Message_Reply_Conversation__c": string;
  "Message__c": string;
  "Original_Post__c": boolean;
  "Parent_Conversation__c": string;
  "Parent_Reply_Conversation__c": string;
  "Priority__c": string;
  "Reply__c": boolean;
  "Title__c": string;
  "IsServiceODelete": boolean;
  "documentCount": number;
  "APEX_PgMO_Tasks__c": string;
  "Selected_Member__c": string;
  "PgMO_Tasks__c": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  owner: Users;
  worker: Worker;
  parentId: Conversation;
  ReplyId: Conversation;
  parentConversation: Conversation[];
  replyConversation: Conversation[];
  replyMainMessageConversation: Conversation[];
  task: Task;
  constructor(data?: ConversationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Conversation`.
   */
  public static getModelName() {
    return "Conversation";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Conversation for dynamic purposes.
  **/
  public static factory(data: ConversationInterface): Conversation{
    return new Conversation(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Conversation',
      plural: 'Conversations',
      path: 'Conversations',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "OwnerId": {
          name: 'OwnerId',
          type: 'string'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "Conversation_Date__c": {
          name: 'Conversation_Date__c',
          type: 'Date'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "CreatedDate": {
          name: 'CreatedDate',
          type: 'Date'
        },
        "Followers__c": {
          name: 'Followers__c',
          type: 'number'
        },
        "Initated_By_Member__c": {
          name: 'Initated_By_Member__c',
          type: 'string'
        },
        "IsDeleted": {
          name: 'IsDeleted',
          type: 'boolean'
        },
        "Likes__c": {
          name: 'Likes__c',
          type: 'number'
        },
        "LastModifiedDate": {
          name: 'LastModifiedDate',
          type: 'Date'
        },
        "LastReferencedDate": {
          name: 'LastReferencedDate',
          type: 'Date'
        },
        "LastViewedDate": {
          name: 'LastViewedDate',
          type: 'Date'
        },
        "Main_Message_Reply_Conversation__c": {
          name: 'Main_Message_Reply_Conversation__c',
          type: 'string'
        },
        "Message__c": {
          name: 'Message__c',
          type: 'string'
        },
        "Original_Post__c": {
          name: 'Original_Post__c',
          type: 'boolean'
        },
        "Parent_Conversation__c": {
          name: 'Parent_Conversation__c',
          type: 'string'
        },
        "Parent_Reply_Conversation__c": {
          name: 'Parent_Reply_Conversation__c',
          type: 'string'
        },
        "Priority__c": {
          name: 'Priority__c',
          type: 'string'
        },
        "Reply__c": {
          name: 'Reply__c',
          type: 'boolean'
        },
        "Title__c": {
          name: 'Title__c',
          type: 'string'
        },
        "IsServiceODelete": {
          name: 'IsServiceODelete',
          type: 'boolean'
        },
        "documentCount": {
          name: 'documentCount',
          type: 'number'
        },
        "APEX_PgMO_Tasks__c": {
          name: 'APEX_PgMO_Tasks__c',
          type: 'string'
        },
        "Selected_Member__c": {
          name: 'Selected_Member__c',
          type: 'string'
        },
        "PgMO_Tasks__c": {
          name: 'PgMO_Tasks__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        owner: {
          name: 'owner',
          type: 'Users',
          model: 'Users',
          relationType: 'belongsTo',
                  keyFrom: 'OwnerId',
          keyTo: 'sfdcId'
        },
        worker: {
          name: 'worker',
          type: 'Worker',
          model: 'Worker',
          relationType: 'belongsTo',
                  keyFrom: 'Initated_By_Member__c',
          keyTo: 'sfdcId'
        },
        parentId: {
          name: 'parentId',
          type: 'Conversation',
          model: 'Conversation',
          relationType: 'belongsTo',
                  keyFrom: 'Parent_Conversation__c',
          keyTo: 'sfdcId'
        },
        ReplyId: {
          name: 'ReplyId',
          type: 'Conversation',
          model: 'Conversation',
          relationType: 'belongsTo',
                  keyFrom: 'Parent_Reply_Conversation__c',
          keyTo: 'sfdcId'
        },
        parentConversation: {
          name: 'parentConversation',
          type: 'Conversation[]',
          model: 'Conversation',
          relationType: 'hasMany',
                  keyFrom: 'sfdcId',
          keyTo: 'Parent_Conversation__c'
        },
        replyConversation: {
          name: 'replyConversation',
          type: 'Conversation[]',
          model: 'Conversation',
          relationType: 'hasMany',
                  keyFrom: 'sfdcId',
          keyTo: 'Parent_Reply_Conversation__c'
        },
        replyMainMessageConversation: {
          name: 'replyMainMessageConversation',
          type: 'Conversation[]',
          model: 'Conversation',
          relationType: 'hasMany',
                  keyFrom: 'sfdcId',
          keyTo: 'Main_Message_Reply_Conversation__c'
        },
        task: {
          name: 'task',
          type: 'Task',
          model: 'Task',
          relationType: 'belongsTo',
                  keyFrom: 'PgMO_Tasks__c',
          keyTo: 'sfdcId'
        },
      }
    }
  }
}
